export default {
  // Tabs
  'webConfig.tabs.login': 'Configuración de Inicio de Sesión y Registro',
  'webConfig.tabs.thirdParty': 'Configuración de Inicio de Sesión de Terceros',
  'webConfig.tabs.appManage': 'Gestión de Aplicaciones',
  'webConfig.tabs.livechat': 'Configuración de Livechat',
  'webConfig.tabs.otherConfig': 'Otras Configuraciones',
  'webConfig.tabs.reportConfig': 'Reportes Regulatorios',

  // Regulatory Reporting Config
  'webConfig.reportConfig.title': 'Proporción de Reportes',
  'webConfig.reportConfig.tip': 'Solo aplica a usuarios nuevamente registrados; el estado de reporte de usuarios existentes no se ve afectado. Efectivo inmediatamente después de guardar.',
  'webConfig.reportConfig.currentRatio': 'Proporción actual',
  'webConfig.reportConfig.report': '(Ruta A)',
  'webConfig.reportConfig.notReport': '(Ruta B)',
  'webConfig.reportConfig.lastModify': 'Última modificación por',
  'webConfig.reportConfig.version': 'Versión',
  'webConfig.reportConfig.adjustTo': 'Ajustar a',
  'webConfig.reportConfig.save': 'Guardar',
  'webConfig.reportConfig.historyTitle': 'Últimos 10 cambios',
  'webConfig.reportConfig.col.version': 'Versión',
  'webConfig.reportConfig.col.time': 'Hora',
  'webConfig.reportConfig.col.operator': 'Operador',
  'webConfig.reportConfig.col.change': 'Antiguo → Nuevo',
  'webConfig.reportConfig.col.reason': 'Razón',
  'webConfig.reportConfig.confirmTitle': 'Confirmar cambio de proporción',
  'webConfig.reportConfig.confirmContent': '¿Ajustar la proporción de reportes a {{ratio}}%? Efectivo inmediatamente.',
  'webConfig.reportConfig.reasonPh': 'Razón del cambio (opcional, para auditoría)',
  'webConfig.reportConfig.saveSuccess': 'Guardado',
  'webConfig.reportConfig.saveFail': 'Falló al guardar',
  'webConfig.reportConfig.fetchError': 'Falló la carga',
  'webConfig.reportConfig.invalidRatio': 'Ingrese un entero 0~100',

  // Game route auto-upgrade strategy
  'webConfig.routeStrategy.title': 'Estrategia de Ruta de Juegos',
  'webConfig.routeStrategy.tip': 'Los usuarios nuevos por defecto están en Ruta B y se actualizan automáticamente a Ruta A una vez alcanzado el umbral (irreversible). Ambas estrategias pueden coexistir (cumplir cualquiera para actualizar); miembros cambiados manualmente ya no se ven afectados por estrategias automáticas.',
  'webConfig.routeStrategy.strategyTitle': 'Habilitar estrategias',
  'webConfig.routeStrategy.depositStrategy': 'Por umbral de depósito acumulativo',
  'webConfig.routeStrategy.vipStrategy': 'Por nivel VIP',
  'webConfig.routeStrategy.vipLevelLabel': 'Actualizar nivel VIP',
  'webConfig.routeStrategy.addCurrency': 'Añadir moneda',
  'webConfig.routeStrategy.remove': 'Eliminar',
  'webConfig.routeStrategy.save': 'Guardar',
  'webConfig.routeStrategy.col.currency': 'Moneda',
  'webConfig.routeStrategy.col.amount': 'Umbral',
  'webConfig.routeStrategy.col.enabled': 'Habilitado',
  'webConfig.routeStrategy.col.action': 'Acción',
  'webConfig.routeStrategy.saveSuccess': 'Guardado exitosamente',
  'webConfig.routeStrategy.saveFail': 'Falló al guardar',
  'webConfig.routeStrategy.fetchError': 'Falló la carga',
  'webConfig.routeStrategy.thresholdInvalid': 'Los umbrales de moneda habilitados requieren moneda y monto',
  'webConfig.routeStrategy.currencyDuplicate': 'La moneda no puede duplicarse',
  'webConfig.routeStrategy.vipLevelRequired': 'Ingrese el nivel VIP de actualización',

  // Login Register Config
  'webConfig.login.inviteCode': 'Código de Invitación',
  'webConfig.login.inviteCodeRequired': 'Código de Invitación Requerido:',
  'webConfig.login.outletSelection': 'Selección de Establecimiento',
  'webConfig.login.agreementManualCheck': 'Casilla de Términos PAGCOR en Registro',
  'webConfig.login.rgPopupBeforeLogin': 'Ventana Responsible Gaming (Antes de Iniciar Sesión)',
  'webConfig.login.rgPopupAfterLogin': 'Ventana Responsible Gaming (Después de Iniciar Sesión)',
  'webConfig.login.passwordRisk': 'Control de Riesgo de Contraseña de Inicio de Sesión',
  'webConfig.login.passwordRiskMinutes': 'minutos después',
  'webConfig.login.passwordRiskTimes': 'intentos fallidos',
  'webConfig.login.identityInfo': 'Información de Identidad:',
  'webConfig.login.phoneOtp': 'Verificación OTP por Teléfono:',
  'webConfig.login.emailOtp': 'Verificación OTP por Email:',
  'webConfig.login.isRegKaptcha': 'Verificación de Captcha de Registro:',
  'webConfig.login.isRegisterMobileOTP': 'Cambio OTP de registro:',
  'webConfig.login.isBindBankOTP': 'OTP de Vincular Cuenta de Retiro:',
  'webConfig.login.registerCaptcha': 'Tipo de Captcha de Registro:',
  'webConfig.login.captchaType': 'Tipo de Captcha:',
  'webConfig.login.isLoginKaptcha': 'Verificación de Captcha de Inicio de Sesión:',
  'webConfig.login.loginCaptcha': 'Tipo de Captcha de Inicio de Sesión:',
  'webConfig.login.isForgetPassKaptcha': 'Cambio de código de verificación de contraseña olvidada:',
  'webConfig.login.forgetKaptchaType': 'Tipo de código de verificación de contraseña olvidada:',
  'webConfig.login.isStrongPassword': 'Cambio de contraseña fuerte:',
  'webConfig.login.memberPasswordRule': 'Regla de verificación de contraseña de miembro:',
  'webConfig.login.isMultipleDeviceLogin': 'Cambio de inicio de sesión en múltiples dispositivos:',
  'webConfig.login.captcha.ziyan': 'Captcha Desarrollado Internamente',
  'webConfig.login.captcha.yidun': 'Captcha Yidun',
  'webConfig.login.captcha.cloudfare': 'Captcha Cloudfare',
  'webConfig.login.masterCaptcha': 'Cambio Maestro de Captcha:',
  'webConfig.login.masterCaptchaType': 'Tipo de Captcha:',
  'webConfig.login.applicablePages': 'Páginas Aplicables:',
  'webConfig.login.configurePages': 'Configurar Páginas',
  'webConfig.login.page.login': 'Captcha de Página de Inicio de Sesión',
  'webConfig.login.page.forgot': 'Captcha de Contraseña Olvidada',
  'webConfig.login.page.register': 'Captcha de Página de Registro',
  'webConfig.login.page.bindPhone': 'Vincular Teléfono',
  'webConfig.login.page.bindEmail': 'Vincular Email',
  'webConfig.login.page.bindWithdraw': 'Vincular Cuenta de Retiro',
  'webConfig.login.page.kioskQuery': 'Consulta de cuenta y contraseña del kiosco',
  'webConfig.login.masterCaptchaHint': 'Cuando está habilitado, el cliente verifica si la página actual está en la lista de páginas aplicables. Si coincide, aparece un captcha antes de enviar códigos de verificación. La verificación debe pasar antes de enviar códigos. Si no coincide o el cambio maestro está deshabilitado, el flujo original procede.',
  'webConfig.login.atLeastOnePage': 'Seleccione al menos una página aplicable',
  'webConfig.login.noPageConfigured': 'Sin páginas configuradas, el captcha no tendrá efecto',
  'webConfig.login.changePassword': 'Cambiar Contraseña:',
  'webConfig.login.changePassword.phone': 'Verificación OTP por Teléfono',
  'webConfig.login.changePassword.email': 'Verificación OTP por Email',
  'webConfig.login.mobileLoginBg': 'Fondo de Inicio de Sesión Móvil:',
  'webConfig.login.mobileRegisterBg': 'Fondo de Registro Móvil:',
  'webConfig.login.pcLoginBg': 'Fondo de Inicio de Sesión de PC:',
  'webConfig.login.pcRegisterBg': 'Fondo de Registro de PC:',
  'webConfig.login.deviceLimit': 'Límite de Registro de Mismo Dispositivo (Cambio):',
  'webConfig.login.deviceLimitTime': 'Período de Estadísticas (Horas):',
  'webConfig.login.deviceNum': 'Cantidad de Registros Permitidos:',
  'webConfig.login.ipLimit': 'Límite de Registro de Mismo IP (Cambio):',
  'webConfig.login.ipLimitTime': 'Período de Estadísticas (Horas):',
  'webConfig.login.ipLimitNum': 'Cantidad de Registros Permitidos:',
  'webConfig.login.save': 'Guardar',
  'webConfig.login.phoneBind': 'Vinculación de Teléfono',
  'webConfig.login.emailBind': 'Vinculación de Email',
  'webConfig.login.allowSkip': 'Permitir Omitir',

  // Third Party Config
  'webConfig.thirdParty.google': 'Inicio de Sesión Google:',
  'webConfig.thirdParty.facebook': 'Inicio de Sesión Facebook:',
  'webConfig.thirdParty.manualCreate': 'Verificación Móvil de Inicio de Sesión de Terceros:',
  'webConfig.thirdParty.googleClientId': 'ID de Cliente Google:',
  'webConfig.thirdParty.googleAndroidClientId': 'ID de Cliente de Aplicación Android de Google:',
  'webConfig.thirdParty.googleIosClientId': 'ID de Cliente iOS de Google:',
  'webConfig.thirdParty.googleLoginUrl': 'URL de Inicio de Sesión Google:',
  'webConfig.thirdParty.facebookAppId': 'ID de Aplicación Facebook:',
  'webConfig.thirdParty.facebookAppSecret': 'Secreto de Aplicación Facebook:',
  'webConfig.thirdParty.facebookLoginUrl': 'URL de Inicio de Sesión Facebook:',
  'webConfig.thirdParty.appleAppClientId': 'ID de Bundle iOS de Apple:',

  // App Management
  'webConfig.app.channel': 'Canal',
  'webConfig.app.appType': 'Tipo de Aplicación',
  'webConfig.app.forceUpgrade': 'Actualización Forzada',
  'webConfig.app.version': 'Versión',
  'webConfig.app.downloadUrl': 'URL de Descarga',
  'webConfig.app.status': 'Estado',
  'webConfig.app.status.enabled': 'Habilitado',
  'webConfig.app.status.disabled': 'Deshabilitado',
  'webConfig.app.actions': 'Acciones',
  'webConfig.app.edit': 'Editar',
  'webConfig.app.delete': 'Eliminar',
  'webConfig.app.disable': 'Deshabilitar',
  'webConfig.app.enable': 'Habilitar',
  'webConfig.app.editTitle': 'Editar Configuración de Aplicación',
  'webConfig.app.downloadSettings': 'Configuración de Descarga de Aplicación',
  'webConfig.app.cancel': 'Cancelar',
  'webConfig.app.confirm': 'Confirmar',

  // Livechat Config
  'webConfig.livechat.clientId': 'ID de Cliente LiveChat:',
  'webConfig.livechat.grantType': 'Tipo de Autorización LiveChat:',
  'webConfig.livechat.licenseId': 'ID de Licencia LiveChat:',
  'webConfig.livechat.responseType': 'Tipo de Respuesta LiveChat:',
  'webConfig.livechat.redirectUrl': 'URL de Redirección LiveChat:',
  'webConfig.livechat.backupUrl': 'URL de Respaldo de Servicio al Cliente:',

  // SEO - Google Search Console
  'webConfig.tabs.gsc': 'Google Search Console (Estadísticas de Índice SEO)',
  'webConfig.gsc.siteUrl': 'Propiedad del Sitio GSC:',
  'webConfig.gsc.siteUrlDesc': 'Propiedad de Search Console, ej. sc-domain:example.com o https://example.com/',
  'webConfig.gsc.siteBaseUrl': 'URL Base del Sitio SEO:',
  'webConfig.gsc.siteBaseUrlDesc': 'El origen del sitio donde realmente viven las páginas de artículos, usado para construir URLs absolutas para el mapa de sitio y verificaciones de índice. Requerido cuando la propiedad GSC anterior es un dominio (ej. sc-domain:example.com) pero los artículos están en un subdominio (ej. https://www.example.com). Deje vacío para retroceder a la Propiedad del Sitio GSC.',
  'webConfig.gsc.serviceAccountJson': 'JSON de Cuenta de Servicio GSC:',
  'webConfig.gsc.serviceAccountJsonPlaceholder': 'Pegue el archivo .json de cuenta de servicio completo descargado de Google Cloud tal cual (no edite manualmente). ej. { "type": "service_account", "project_id": "...", "private_key": "...", "client_email": "xxx@xxx.iam.gserviceaccount.com", ... }',
  'webConfig.gsc.serviceAccountJsonDesc': 'Pegue el JSON completo de la clave de cuenta de servicio de Google. La cuenta de servicio debe agregarse como usuario de esta propiedad en Search Console. Deje vacío y "Indexado / Excluido" mostrará "-".',
  'webConfig.gsc.syncBatchSize': 'Páginas por sincronización:',
  'webConfig.gsc.syncBatchSizeDesc': 'Cantidad máxima de páginas que cada ejecución programada inspecciona (incremental, menos recientemente sincronizadas primero). Limitado por cuota GSC (2000/día): este valor × ejecuciones-por-día debe ser ≤ 2000. Para cada 15 min (96 ejecuciones/día), mantenga ≤ 20. Vacío = predeterminado 20; 0 = todas las páginas (usar con cuidado).',

  // Other Config
  'webConfig.other.pointExpire': 'Expiración de Puntos:',
  'webConfig.other.adminGoogleAuth': 'Autenticador Google de Administrador:',
  'webConfig.other.kycProcess': 'Proceso de Verificación KYC:',
  'webConfig.other.kycAutoApprove': 'Aprobación Automática KYC:',
  'webConfig.other.kycRegisterForce': 'Registrarse para certificación KYC obligatoria:',
  'webConfig.other.KycSimplify': 'KYC de Registro:',
  'webConfig.other.kycRegisterWithdraw': 'KYC de Retiro:',
  'webConfig.other.KycAgent': 'Agente Omitir KYC de Registro:',
  'webConfig.other.isOpenBlackList': 'Verificación de Lista Negra KYC:',
  'webConfig.other.kycWithDrawAgent': 'Agente Omitir KYC de Retiro:',
  'webConfig.other.KycInterceptorsPath': 'Ruta de interceptación KYC:',
  'webConfig.other.withdrawKYCVerifyDateNum': 'Período de validez de fallo de KYC de retiro:',
  'webConfig.other.withdrawKYCVerifyTimes': 'Cantidad de recordatorios KYC de retiro:',
  'webConfig.other.withdrawKYCInterceptorsPath': 'Ruta de interceptación de fallo de KYC de retiro:',
  'webConfig.other.adminLogo': 'URL de Logo de Administrador:',
  'webConfig.other.vapeSafeMode': 'Modo Seguro Vape:',
  'webConfig.other.imageUrl': 'URL de Acceso de Imágenes:',
  'webConfig.other.gameImageUrl': 'URL de Acceso de Imágenes de Juegos:',
  'webConfig.other.payCallbackDomain': 'Dominio de Devolución de Llamada de Pago:',
  'webConfig.other.allowedCountries': 'Países Permitidos del Frontend:',
  'webConfig.other.vipMaxLevel': 'Pantalla de Nivel Máximo VIP',
  'webConfig.other.vipMaxLevelDesc': 'Controla la cantidad de niveles VIP mostrados en el frontend. Asegúrese de establecer el valor de crecimiento del nivel seleccionado en infinito.',
  'webConfig.other.vipRewardWeeklyPayoutDay': 'Fecha de pago de salario semanal VIP',
  'webConfig.other.vipRewardWeeklyPayoutDayDesc': 'Admite números 1-7 (Lunes = 1), en inglés MONDAY..SUNDAY',
  'webConfig.other.vipRewardWeeklyWindowDays': 'Días de estadísticas de salario semanal VIP',
  'webConfig.other.rtpRange': 'Rango de Visualización de RTP',
  'webConfig.other.appDownloadLandingPage': 'URL de Página de Destino de Descarga de Aplicación:',
  'webConfig.other.appAndroidDownloadLandingPage': 'URL de Página de Destino de Descarga de Aplicación Android:',
  'webConfig.other.appAndroidVersion': 'Número de versión de aplicación Android:',
  'webConfig.other.appAndroidForceUpdate': 'Actualización forzada de aplicación Android:',
  'webConfig.other.activeUserAgent': 'Agente de Usuario Activo:',
  'webConfig.other.activeUserAgentPlaceholder': 'Seleccione agente de usuario activo',
  'webConfig.other.indexLoading': 'Animación de Arranque:',
  'webConfig.other.balanceLimit.title': 'Información de Cuenta - Ajuste Manual',
  'webConfig.other.balanceLimit.addMax': 'Límite de Monto de Aumento:',
  'webConfig.other.balanceLimit.addMaxPlaceholder': 'Ingrese el límite de monto de aumento',
  'webConfig.other.balanceLimit.reduceMax': 'Límite de Monto de Disminución:',
  'webConfig.other.balanceLimit.reduceMaxPlaceholder': 'Ingrese el límite de monto de disminución',
  'webConfig.other.balanceLimit.numberRule': 'Ingrese un número mayor que 1',
  'webConfig.other.nonNegativeNumberRule': 'Ingrese un número mayor o igual a 0',
  'webConfig.other.pointLimit.title': 'Puntos de Miembro - Ajuste Manual de Puntos de Miembro',
  'webConfig.other.pointLimit.addMax': 'Límite de Aumento de Puntos de Miembro:',
  'webConfig.other.pointLimit.addMaxPlaceholder': 'Ingrese el límite de aumento de puntos de miembro',
  'webConfig.other.pointLimit.reduceMax': 'Límite de Disminución de Puntos de Miembro:',
  'webConfig.other.pointLimit.reduceMaxPlaceholder': 'Ingrese el límite de disminución de puntos de miembro',
  'webConfig.other.pointLimit.numberRule': 'Ingrese un número mayor que 1',
  'webConfig.other.opUserAgentAllocLimit.title': 'Cuenta Backend → Límite de Asignación Por Transacción de Agente',
  'webConfig.other.opUserAgentAllocLimit.desc': 'Controla el límite por transacción cuando una cuenta backend asigna cuota a un agente L1 o L2 (PHP / VND / CNY independientes)',
  'webConfig.other.opUserAgentAllocLimit.addMax': 'Límite de Aumento Por Transacción:',
  'webConfig.other.opUserAgentAllocLimit.addMaxPlaceholder': 'Ingrese el límite de aumento por transacción',
  'webConfig.other.opUserAgentAllocLimit.reduceMax': 'Límite de Disminución Por Transacción:',
  'webConfig.other.opUserAgentAllocLimit.reduceMaxPlaceholder': 'Ingrese el límite de disminución por transacción',
  'webConfig.other.agentAllocLimit.title': 'Límite de Asignación de Agente',
  'webConfig.other.agentAllocLimit.desc': 'Controla el límite por transacción cuando un agente L1 asigna cuota a un agente L2 (aplica solo al objetivo "Cuota de Ajuste")',
  'webConfig.other.agentAllocLimit.addMax': 'Límite de Aumento Por Transacción:',
  'webConfig.other.agentAllocLimit.addMaxPlaceholder': 'Ingrese el límite de aumento por transacción',
  'webConfig.other.agentAllocLimit.reduceMax': 'Límite de Disminución Por Transacción:',
  'webConfig.other.agentAllocLimit.reduceMaxPlaceholder': 'Ingrese el límite de disminución por transacción',

  // Common
  'webConfig.common.yes': 'Sí',
  'webConfig.common.no': 'No',
  'webConfig.common.saveSuccess': 'Guardado exitosamente',
  'webConfig.common.saveFailed': 'Falló al guardar',
  'webConfig.common.updateSuccess': 'Actualizado exitosamente',
  'webConfig.common.updateFailed': 'Falló la actualización',
  'webConfig.common.disableSuccess': 'Deshabilitado exitosamente',
  'webConfig.common.disableFailed': 'Falló la deshabilitación',
  'webConfig.common.enableSuccess': 'Habilitado exitosamente',
  'webConfig.common.enableFailed': 'Falló la habilitación',
  'webConfig.common.deleteSuccess': 'Eliminado exitosamente',
  'webConfig.common.deleteFailed': 'Falló la eliminación',
  'sys.enterCorrectEmail': 'Ingrese una dirección de correo electrónico válida',

  // Etiquetas de elementos de diccionario: clave = dict.<groupCode>.<itemCode>
  // (códigos neutrales de idioma de dict_group_item). Compartidas entre módulos.
  // Nunca mostrar directamente item_name / item_name_en del backend.
  // 21005 tipo de aplicación
  'dict.21005.21005001': 'iOS',
  'dict.21005.21005002': 'Android',
  // 21006 canal de aplicación
  'dict.21006.21006001': 'Super Sign',
  'dict.21006.21006002': 'App Store',
  'dict.21006.21006003': 'Google Play',
  'dict.21006.21006004': 'Tienda XIAOMI',
  'dict.21006.21006005': 'Tienda CHUANYIN',
  'dict.21006.21006006': 'VIVO',
  'dict.21006.21006007': 'OPPO',
  'dict.21006.21006008': 'Huawei',
  // 80002 tipo de correo / formato de correo
  'dict.80002.80002001': 'Correo Microsoft',
  'dict.80002.80002002': 'Correo Google',
  'dict.80002.80002003': 'mailgun',
  // 80003 tipo de negocio de correo
  'dict.80003.80003001': 'Envío de Código de Verificación',
};
